'use client';
/**
 * Производит быструю конкатенацию массивов.
 *
 * @typeParam T - Элемент массива.
 *
 * @param array - Массив или одно значение.
 * @param chunkSize - Количество элементов в пакете.
 *
 * @returns Объединённый массив.
 *
 * @primaryExample
 * concat([[1, 2], [3, 4], [5]], 2) // [1, 2, 3, 4, 5]
 *
 * @stable
 * */ var concat = function(arrays) {
    return [].concat.apply([], arrays);
};

export { concat };
